import styled from "styled-components";
import Tooltip from "./tooltip";
import {
  getErrorMessage,
  getErrorDescription,
} from "../utils/transactionFormatter";

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;

  &.success {
    background-color: #10b981;
    color: white;
  }

  &.failed {
    background-color: #ef4444;
    color: white;
    cursor: help;
  }

  &.pending {
    background-color: #f59e0b;
    color: white;
  }
`;

const ErrorTooltip = styled.div`
  max-width: 300px;

  .error-title {
    font-weight: 600;
    margin-bottom: 4px;
  }

  .error-description {
    font-size: 13px;
    opacity: 0.9;
  }
`;

export default function StatusBadge({ extrinsic }) {
  if (!extrinsic) {
    return "--";
  }

  // For simple display (just success/failed)
  if (extrinsic.isSuccess === true) {
    return <Badge className="success">Success</Badge>;
  }

  if (extrinsic.isSuccess === false) {
    // Try to get error details if available
    let errorContent = "Failed";
    let tooltipContent = null;

    if (extrinsic.error) {
      const errorMessage = getErrorMessage(extrinsic.error);
      const errorDescription = getErrorDescription(extrinsic.error);

      errorContent = `Failed: ${errorMessage}`;

      if (errorDescription) {
        tooltipContent = (
          <ErrorTooltip>
            <div className="error-title">{errorMessage}</div>
            <div className="error-description">{errorDescription}</div>
          </ErrorTooltip>
        );
      }
    } else {
      errorContent = "Failed";
    }

    if (tooltipContent) {
      return (
        <Tooltip tip={tooltipContent}>
          <Badge className="failed">{errorContent}</Badge>
        </Tooltip>
      );
    }

    return <Badge className="failed">{errorContent}</Badge>;
  }

  // Pending/unfinalized
  return <Badge className="pending">Pending</Badge>;
}
